var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 156H16V356H496V156Z",
    fill: "#C0392B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 386H16V496H496V386Z",
    fill: "#3498DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 356H16V386H496V356Z",
    fill: "#F1C40F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 126H16V156H496V126Z",
    fill: "#F1C40F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V126H496V16Z",
    fill: "#3498DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M459.199 252.357H52.8003C50.8141 252.357 49.2039 253.991 49.2039 256.007C49.2039 258.022 50.8141 259.656 52.8003 259.656H459.199C461.186 259.656 462.796 258.022 462.796 256.007C462.796 253.991 461.186 252.357 459.199 252.357Z",
    fill: "#FFD900",
    stroke: "black",
    strokeWidth: 1.0797
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M417.952 217.07L397.273 224.369L417.952 231.668L438.632 224.369L417.952 217.07V217.07Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M404.349 221.941H105.528C104.067 221.941 102.883 223.031 102.883 224.374C102.883 225.718 104.067 226.807 105.528 226.807H404.349C405.809 226.807 406.993 225.718 406.993 224.374C406.993 223.031 405.809 221.941 404.349 221.941Z",
    fill: "#FFD900",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M399.721 226.804C400.936 226.804 402.155 225.587 402.155 224.371C402.155 223.154 400.936 221.938 399.721 221.938",
    fill: "#FFD900"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M399.721 226.804C400.936 226.804 402.155 225.587 402.155 224.371C402.155 223.154 400.936 221.938 399.721 221.938",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M397.285 226.804C398.501 226.804 399.72 225.587 399.72 224.371C399.72 223.154 398.501 221.938 397.285 221.938",
    fill: "#FFD900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M397.285 226.804C398.501 226.804 399.72 225.587 399.72 224.371C399.72 223.154 398.501 221.938 397.285 221.938",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M394.85 226.804C396.065 226.804 397.284 225.587 397.284 224.371C397.284 223.154 396.065 221.938 394.85 221.938",
    fill: "#FFD900"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M394.85 226.804C396.065 226.804 397.284 225.587 397.284 224.371C397.284 223.154 396.065 221.938 394.85 221.938",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M398.486 231.674L377.806 238.973L398.486 246.272L419.166 238.973L398.486 231.674Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M384.888 236.537H86.0674C84.6069 236.537 83.423 237.626 83.423 238.97C83.423 240.314 84.6069 241.403 86.0674 241.403H384.888C386.349 241.403 387.533 240.314 387.533 238.97C387.533 237.626 386.349 236.537 384.888 236.537Z",
    fill: "#FFD900",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M380.255 241.407C381.47 241.407 382.689 240.191 382.689 238.974C382.689 237.758 381.47 236.541 380.255 236.541",
    fill: "#FFD900"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M380.255 241.407C381.47 241.407 382.689 240.191 382.689 238.974C382.689 237.758 381.47 236.541 380.255 236.541",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M377.819 241.407C379.035 241.407 380.253 240.191 380.253 238.974C380.253 237.758 379.035 236.541 377.819 236.541",
    fill: "#FFD900"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M377.819 241.407C379.035 241.407 380.253 240.191 380.253 238.974C380.253 237.758 379.035 236.541 377.819 236.541",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M375.384 241.407C376.599 241.407 377.818 240.191 377.818 238.974C377.818 237.758 376.599 236.541 375.384 236.541",
    fill: "#FFD900"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M375.384 241.407C376.599 241.407 377.818 240.191 377.818 238.974C377.818 237.758 376.599 236.541 375.384 236.541",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M375.375 256.002C351.046 280.33 318.605 328.988 253.725 328.988C196.954 328.988 156.411 280.33 132.074 256.002C156.403 231.67 196.951 183.012 253.725 183.012C318.602 183.012 351.038 231.67 375.375 256.002Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.0079
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M245.235 208.401C251.707 215.682 246.303 218.616 253.154 219.094C260.379 219.625 256.283 226.787 262.361 227.035C266.61 227.221 261.936 244.195 266.027 249.796C270.193 255.636 273.683 251.507 273.756 255.726C273.828 260.089 262.416 259.649 262.216 273.089C261.881 280.834 252.585 281.33 252.141 286.314C251.59 291.001 270.455 293.633 270.203 297.829C269.945 302.013 249.833 301.358 248.957 306.129C248.508 310.414 276.586 313.927 278.845 326.322C274.655 327.692 262.734 328.982 253.725 328.989C196.964 329.03 156.411 280.326 132.083 255.998C156.412 231.666 196.96 183.008 253.734 183.008C253.734 183.008 236.883 198.405 245.243 208.396L245.235 208.401Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M183.393 230.047H177.495V249.51H183.393V230.047Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M183.393 262.49H177.495V281.954H183.393V262.49Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M195.187 230.047H189.289V249.51H195.187V230.047Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M195.187 262.49H189.289V281.954H195.187V262.49Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M206.989 230.047H201.091V249.51H206.989V230.047Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M206.989 262.49H201.091V281.954H206.989V262.49Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M218.783 230.047H212.885V249.51H218.783V230.047Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M218.783 262.49H212.885V281.954H218.783V262.49Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M230.577 230.047H224.679V249.51H230.577V230.047Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M230.577 262.49H224.679V281.954H230.577V262.49Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M242.371 230.047H236.472V249.51H242.371V230.047Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M242.371 262.49H236.472V281.954H242.371V262.49Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M272.6 230.047H266.702V249.51H272.6V230.047Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M272.6 262.49H266.702V281.954H272.6V262.49Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M284.394 230.047H278.496V249.51H284.394V230.047Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M284.394 262.49H278.496V281.954H284.394V262.49Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M296.196 230.047H290.298V249.51H296.196V230.047Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M296.196 262.49H290.298V281.954H296.196V262.49Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M307.99 230.047H302.092V249.51H307.99V230.047Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M307.99 262.49H302.092V281.954H307.99V262.49Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M319.784 230.047H313.886V249.51H319.784V230.047Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M319.784 262.49H313.886V281.954H319.784V262.49Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M331.578 230.047H325.68V249.51H331.578V230.047Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M331.578 262.49H325.68V281.954H331.578V262.49Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M433.706 253.107C430.02 259.491 436.534 250.985 452.427 261.67C455.372 263.656 457.945 268.899 457.945 272.535C457.198 272.035 456.643 270.922 455.819 270.2C454.666 271.356 456.92 276.652 457.249 279.155C454.765 277.765 455.004 277.106 454.178 275.398C454.343 277.463 453.752 283.153 454.74 285.344C452.782 284.785 452.912 283.208 451.889 282.891C452.585 285.372 451.283 288.07 451.628 290.858C450.484 289.725 449.265 288.838 448.733 288.38C448.644 289.708 446.532 293.197 446.484 294.452C445.513 293.866 445.25 292.951 445.088 292.335C443.881 293.851 439.592 299.452 439.316 301.161C436.011 298.242 427.546 291.134 426.444 287.361C425.469 289.502 424.06 290.225 421.272 291.789C420.171 285.809 416.052 279.088 418.255 273.963C416.695 274.888 415.409 275.814 413.849 276.953C415.327 268.293 422.865 258.138 433.706 253.109L433.706 253.107Z",
    fill: "#3D5DA7",
    stroke: "black",
    strokeWidth: 0.855
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M419.962 284.716C421.492 281.658 422.901 280.688 423.89 278.719C425.637 275.257 425.886 272.503 427.408 272.907C428.93 273.31 428.928 274.728 426.956 278.132C424.985 281.535 424.048 282.262 419.962 284.716H419.962Z",
    fill: "#A70000"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M430.308 292.005C430.112 289.677 430.787 288.704 430.664 287.204C430.453 284.565 429.374 282.754 430.777 282.625C432.18 282.496 432.836 283.396 432.841 286.056C432.845 288.715 432.433 289.414 430.308 292.005H430.308Z",
    fill: "#A70000"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M438.159 296.57C437.546 293.319 438.005 291.877 437.613 289.782C436.929 286.097 435.578 283.671 436.879 283.334C438.179 282.997 438.964 284.189 439.456 287.926C439.949 291.663 439.689 292.69 438.159 296.57L438.159 296.57Z",
    fill: "#A70000"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M446.325 273.79C444.408 272.335 443.288 272.237 442.052 271.302C439.874 269.661 438.771 267.904 438.071 268.776C437.37 269.649 437.867 270.602 440.15 272.116C442.432 273.63 443.205 273.75 446.325 273.79Z",
    fill: "#A70000"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M444.972 284.58C443.961 282.481 442.897 281.949 442.243 280.598C441.088 278.225 441.086 276.172 439.832 276.698C438.579 277.225 438.478 278.3 439.819 280.597C441.159 282.893 441.861 283.309 444.971 284.58H444.972Z",
    fill: "#A70000"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0614 259.255C66.8556 257.396 67.2528 257.173 66.1097 255.771C67.7741 256.468 67.8377 258.319 69.8614 257.005C70.605 256.62 70.9289 256.608 70.0255 254.543C72.1362 254.641 79.0484 257.011 80.1554 257.066C83.062 257.2 88.3676 254.013 92.0506 257.932C95.585 261.505 94.4049 265.213 94.4049 270.161C92.9849 269.481 93.6688 269.146 92.1618 267.376C93.292 271.701 92.1012 279.5 92.1012 284.087C91.521 282.981 91.6065 283.461 91.039 282.315C89.532 286.502 87.7254 287.364 87.7254 292.312C87.1815 290.372 87.7065 290.782 87.1013 289.761C85.6366 292.94 75.8099 295.657 79.5965 298.861C76.1785 296.857 74.6798 297.067 73.1297 295.265C72.4624 295.696 71.9313 296.512 71.311 297.63C65.3018 294.865 67.4504 288.902 62.7428 284.918C61.928 286.588 62.2995 286.346 61.4188 289.064C60.4656 285.289 60.2054 282.889 59.1334 280.114C58.2082 281.653 58.2913 281.063 56.6119 283.388C55.9174 278.789 54.7864 277.703 55.2335 274.66C53.4488 275.919 54.6169 275.409 52.833 276.959C54.5231 265.174 61.8235 256.465 67.0622 259.254L67.0614 259.255Z",
    fill: "#3D5DA7",
    stroke: "black",
    strokeWidth: 1.067
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6684 278.49C61.2165 274.696 62.6123 273.504 63.6125 271.062C65.379 266.768 65.6668 263.336 67.1513 263.86C68.6358 264.383 68.6115 266.151 66.6258 270.37C64.6402 274.589 63.7106 275.483 59.6683 278.49H59.6684Z",
    fill: "#A70000"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5304 287.986C66.1509 284.584 67.1305 283.345 67.5331 281.154C68.2479 277.301 67.8494 274.433 69.2287 274.584C70.6081 274.735 70.9202 276.189 70.0023 280.021C69.0845 283.853 68.4509 284.761 65.5304 287.986H65.5304Z",
    fill: "#A70000"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5419 294.586C72.7168 291.288 73.4895 290 73.605 287.876C73.8146 284.14 73.0951 281.464 74.4108 281.449C75.7266 281.434 76.1949 282.778 75.7919 286.518C75.3888 290.259 74.9019 291.192 72.5419 294.586L72.5419 294.586Z",
    fill: "#A70000"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M87.598 273.016C84.7189 270.148 82.9781 269.613 81.1214 267.768C77.8498 264.528 76.269 261.487 75.1044 262.565C73.9398 263.643 74.64 265.259 78.0845 268.342C81.5288 271.425 82.7268 271.874 87.5979 273.016L87.598 273.016Z",
    fill: "#A70000"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8438 284.103C83.9684 281.223 82.5922 280.477 81.3818 278.624C79.2468 275.368 78.5133 272.57 77.3025 273.263C76.0916 273.955 76.3623 275.418 78.6763 278.574C80.9903 281.73 81.921 282.311 85.8439 284.103L85.8438 284.103Z",
    fill: "#A70000"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M214.392 195.969C211.022 202.487 220.293 193.801 234.827 204.713C237.521 206.74 241.381 214.75 241.381 218.463C238.287 217.805 232.807 214.75 232.807 214.75C232.807 214.75 239.238 221.192 239.238 228.617C236.966 227.197 235.829 227.41 235.074 225.665C235.074 228.069 237.095 229.601 237.095 233.313C235.454 232.005 234.066 231.132 232.678 230.367C234.822 234.079 228.772 241.282 231.8 243.685C226.505 242.92 221.087 239.537 218.944 235.824C217.808 236.59 217.684 237.792 217.64 239.074C217.807 239.212 209.581 232.967 210.336 230.568C209.233 232.116 209.077 232.967 208.825 234.712C205.803 231.731 203.033 228.751 202.025 224.898C200.682 226.643 200.598 226.643 199.255 228.387C198.248 222.281 198.248 222.499 200.263 217.265C198.835 218.21 197.66 219.155 196.233 220.318C197.585 211.475 204.478 201.105 214.392 195.97L214.392 195.969Z",
    fill: "#3D5DA7",
    stroke: "black",
    strokeWidth: 0.826
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M206.081 227.817C206.62 223.325 207.794 221.633 208.145 218.74C208.771 213.653 208.029 209.935 209.831 210.029C211.634 210.123 212.153 212 211.262 217.076C210.371 222.152 209.62 223.385 206.081 227.817V227.817Z",
    fill: "#A70000"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M215.49 236.043C215.125 232.253 215.825 230.64 215.593 228.199C215.193 223.903 213.866 220.994 215.437 220.726C217.008 220.459 217.803 221.9 217.972 226.236C218.142 230.573 217.722 231.729 215.49 236.043L215.49 236.043Z",
    fill: "#A70000"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M230.18 242.753C228.582 239.474 227.21 238.496 226.178 236.385C224.356 232.675 223.976 229.646 222.571 230.195C221.166 230.744 221.243 232.311 223.272 235.942C225.302 239.573 226.219 240.314 230.18 242.753V242.753Z",
    fill: "#A70000"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M235.263 213.382C231.195 211.241 229.105 211.214 226.483 209.838C221.866 207.425 219.179 204.699 218.225 206.199C217.27 207.699 218.544 209.191 223.304 211.385C228.063 213.579 229.526 213.682 235.263 213.382L235.263 213.382Z",
    fill: "#A70000"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M236.753 225.654C233.791 223.189 232.039 222.826 230.128 221.241C226.762 218.459 225.087 215.727 223.963 216.834C222.838 217.942 223.589 219.405 227.123 222.026C230.655 224.647 231.864 224.972 236.753 225.654V225.654Z",
    fill: "#A70000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/SZ.826f4402a25ef3cc6b92992db55f6021.svg";
export { ForwardRef as ReactComponent };